if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        TextControl,
        TextareaControl
    } = window.wp.components;

    registerBlockType('custom-gutenberg/featured-video', {
        // built-in attributes
        title: 'Featured Video',
        description: 'Custom Featured Video',
        icon: '',
        category: 'custom-content',
        example: {},

        // custom attributes
        attributes: {
            text_1: {
                type: 'string',
                default: '',
            },
            text_2: {
                type: 'string',
                default: '',
            },
            description: {
                type: 'string',
                default: '#ŽiviRapsody<br />#višeodputovanja',
            },
            link: {
                type: 'string',
                default: '',
            },
            viewMore: {
                type: 'string',
                default: 'SAZNAJTE VIŠE',
            },
            video: {
                type: 'string',
                default: '',
            },
            videoTitle: {
                type: 'string',
                default: '',
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                text_1,
                text_2,
                description,
                link,
                viewMore,
                video,
                videoTitle,
            } = attributes;

            // custom functions
            function onTextChange_1 (text_1) {
                setAttributes({text_1: text_1});
            };

            function onTextChange_2 (text_2) {
                setAttributes({text_2: text_2});
            };

            function onDescriptionChange(description) {
                setAttributes({description: description});
            }

            function onLinkChange(link) {
                setAttributes({link: link});
            }

            function onViewMoreChange(viewMore) {
                setAttributes({viewMore: viewMore});
            }

            function onVideoChange(video) {
                setAttributes({video: video});
            }

            function onVideoTitleChange(videoTitle) {
                setAttributes({videoTitle: videoTitle});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <p><strong>Text 1:</strong></p>
                        <TextControl value={ text_1 } onChange={ onTextChange_1 }></TextControl>
                        <br />
                        <p><strong>Text 2:</strong></p>
                        <TextControl value={ text_2 } onChange={ onTextChange_2 }></TextControl>
                        <br />
                        <p><strong>Description:</strong></p>
                        <TextareaControl value={ description } onChange={ onDescriptionChange }></TextareaControl>
                        <br />
                        <p><strong>Enter button url: (ex: /o-nama)</strong></p>
                        <TextControl value={ link } onChange={ onLinkChange }></TextControl>
                        <br />
                        <p><strong>Description</strong></p>
                        <TextareaControl value={ description } onChange={ onDescriptionChange }></TextareaControl>
                        <br />
                        <p><strong>Video: (ex: https://www.youtube.com/embed/kXslUmb7gTs)</strong></p>
                        <TextControl value={ video } onChange={ onVideoChange }></TextControl>
                        <br />
                        <p><strong>Video Title: (ex: Apsolventska Ekskurzija 2018 - aftermovie)</strong></p>
                        <TextControl value={ videoTitle } onChange={ onVideoTitleChange }></TextControl>
                        <br />

                    </PanelBody>
                </InspectorControls>
                ,
                <div class="featured-video row g-0 mt-5 overflow-hidden rounded">
                    <div class="col-lg-4 d-flex flex-column">
                        <div class="bg-dark text-white p-4 p-lg-5 flex-1">
                            <RichText 
                                key="editable" 
                                tagName="p" 
                                class="h5 text-light fw-bold mb-4"
                                placeholder="Više od 200.000 mladih putnika ukazalo nam je povjerenje." 
                                value={ text_1 }
                                onChange={ onTextChange_1 } />
                            <RichText 
                                key="editable" 
                                tagName="p" 
                                class="h5 text-light fw-bold mb-5"
                                placeholder="LIDER u organizovanju omladinskih putovanja." 
                                value={ text_2 }
                                onChange={ onTextChange_2 } />

                            <RichText 
                                key="editable" 
                                tagName="p" 
                                class="fw-bold"
                                placeholder="..." 
                                value={ description }
                                onChange={ onDescriptionChange } />

                            <RichText 
                                key="editable" 
                                tagName="a" 
                                class="btn btn-secondary rounded-pill px-4 py-2 mt-3"
                                placeholder="SAZNAJTE VIŠE" 
                                value={ viewMore }
                                onChange={ onViewMoreChange } />
                        </div>
                    </div>
                    <div class="col-lg">
                        <iframe class="video h-100 w-100" src={ video } title={ videoTitle } frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
            ]
            );
        },

        save({ attributes }) {

            const {
                text_1,
                text_2,
                description,
                link,
                viewMore,
                video,
                videoTitle,
            } = attributes;

            return (
                <div class="featured-video row g-0 mt-5 overflow-hidden rounded">
                    <div class="col-lg-4 d-flex flex-column">
                        <div class="bg-dark text-white p-4 p-lg-5 flex-1">
                            <RichText.Content
                                tagName="p" 
                                class="h5 text-light fw-bold mb-4" 
                                value={ text_1 } />
                            <RichText.Content 
                                tagName="p" 
                                class="h5 text-light fw-bold mb-5" 
                                value={ text_2 } />

                            <RichText.Content 
                                tagName="p" 
                                class="fw-bold" 
                                value={ description } />

                            <a href={ link } class="btn btn-secondary rounded-pill px-4 py-2 mt-3">{ viewMore }</a>
                        </div>
                    </div>
                    <div class="col-lg">
                        <iframe class="video lozad h-100 w-100" src={ video } title={ videoTitle } frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
            );
        },
    });
}